/*
 * javascript to enable styleguide function
 */



/* allows hash specific urls to point to different tabs.
 * Means that a specific url can be used to load the tabbed content desired.
 * Example: http://www/ezdia.com/desk/styleguide.htm#content or
 * http://www/ezdia.com/desk/styleguide.htm#developers
 */
$(function(){
    var hash = window.location.hash;
    hash && $('ul.nav a[href="' + hash + '"]').tab('show');

    $('.nav-pills a').click(function (e) {
        $(this).tab('show');
        var scrollmem = $('body').scrollTop();
        window.location.hash = this.hash;
        $('html,body').scrollTop(scrollmem);
    });
    $('.ez-nav-pills a:not([data-not=tab]):not([data-toggle="dropdown"])').click(function (e) {
        $(this).tab('show');
        var scrollmem = $('body').scrollTop();
        window.location.hash = this.hash;
        $('html,body').scrollTop(scrollmem);
    });
});